import * as React from 'react';
import { getTimePanelDropState } from '../selectors/timePanelDndStoreSelectors';
import { Droppable, DragData } from 'owa-dnd';
import { observer } from 'mobx-react-lite';
import { setShowDayDropHint } from '../actions/timePanelDndStoreActions';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { dropMailItem } from '../actions/dropActions';

export interface DayViewHoverListenerProps {
    children?: React.ReactNode;
}

const HOVER_WAIT_TIME = 500;

/**
 * This component handles listening for emails being dragged over the time panel
 * and accordingly modifying the store to show the drop hint.
 */
const DayViewHoverListener: React.FunctionComponent<DayViewHoverListenerProps> = observer(
    function DayViewHoverListener(props: DayViewHoverListenerProps) {
        const { children } = props;

        return (
            <Droppable
                dropViewState={getTimePanelDropState()}
                onDrop={createTypicalEvent}
                canDrop={alwaysReturnTrue}
                onDragEnter={onDrag}
                greedy={true}
                onDragLeave={onLeave}>
                {children}
            </Droppable>
        );
    }
);

function createTypicalEvent(
    dragInfo: DragData,
    pageX: number,
    pageY: number,
    target?: HTMLElement
) {
    const mailListDragData = dragInfo as MailListRowDragData;
    dropMailItem(mailListDragData, 'TimePanel_DragToDayReplyWithMeeting');
}

function alwaysReturnTrue(dragInfo: DragData): boolean {
    return true;
}

function onDrag() {
    setShowDayDropHint(true);
    window.setTimeout(onLeave, HOVER_WAIT_TIME);
}

function onLeave() {
    setShowDayDropHint(false);
}

export default DayViewHoverListener;
